export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function deCapitalizeFirstLetter(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

export function isEmpty(value) {
  if (value == "" || value == undefined || value == null) {
    return true;
  } else if (value == 0) {
    return false;
  } else {
    return false;
  }
}

export function toMoney(number) {
  if (number) {
    number = number.toString().replace(/\,/g, "");
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}

export function removeComma(number) {
  return number.toString().replace(/\,/g, "");
}
